import { Button, FormControlLabel, Grid, Switch } from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { useReducer, useState } from 'react';
import { Item } from '../../utils/sharedTypes';
import OrderFilterBar from './OrderFilterBar';
import OrderLinkedItemsDisplay from './OrderLinkedItemsDisplay';
import OrdersOptionsBar from './OrdersOptionsBar';
import OrdersTable from './OrdersTable';
import { OrderItemFilter } from './ordersTypes';
import useStyles from './orderLinkedItemsStyles';
import clsx from 'clsx';

const initialFilters: OrderItemFilter = {
  company: null,
  purchaseOrderName: '',
  orderDateFrom: '',
  orderDateTo: '',
};

const Orders = () => {
  const classes = useStyles();
  const [filters, setFilters] = useReducer(
    (curVals: OrderItemFilter, newVals: any) => ({
      ...curVals,
      ...newVals,
    }),
    initialFilters
  );

  const [selectedOrders, setSelectedOrders] = useState<Item[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [includeCompleted, setIncludeCompleted] = useState<boolean>(false);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <div
      className={clsx(classes.content, {
        [classes.contentShift]: open,
      })}
    >
      <OrderFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
      />
      <Grid container justifyContent='space-between'>
        <Grid container item xs spacing={2}>
          <Grid item>
            <OrdersOptionsBar
              selectedOrders={selectedOrders}
              setSelectedOrders={setSelectedOrders}
              editModalOpenFlag={editModalOpenFlag}
              setEditModalOpenFlag={setEditModalOpenFlag}
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={includeCompleted}
                  onChange={() => {
                    setIncludeCompleted((value) => !value);
                  }}
                  color='primary'
                />
              }
              label='Show Completed Orders'
            />
          </Grid>
        </Grid>
        <Grid item>
          <Button
            color='primary'
            className={clsx(open && classes.hide)}
            onClick={() => {
              setOpen(true);
            }}
            endIcon={<ChevronLeft />}
          >
            Order Details
          </Button>
        </Grid>
      </Grid>
      <OrdersTable
        setSelectedOrders={setSelectedOrders}
        filters={filters}
        includeCompleted={includeCompleted}
        setEditModalOpenFlag={setEditModalOpenFlag}
      />
      <OrderLinkedItemsDisplay
        orders={selectedOrders}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default Orders;
